import utils from "@/components/declarations/validators/utils";

export default {
  isValid(self) {
    if (self.$parent.$refs[`screen5`].isAddressSame) {
      return {
        atLeastOne: false
      };
    }
    if (self.isPoland) {
      return self.$refs.polishAddress.isValid();
    }
    const errors = self.$refs.foreignAddress.isValid();

    if (!self.countryName) {
      errors.errors.atLeastOne = true;
      errors.text += "Prosimy o podanie nazwy kraju"
    }

    if (errors.errors.atLeastOne) {
      utils.showMessage(self, errors.text);
    }


    return errors.errors;
  }
}
